import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const LessonCoursesComponent = React.lazy(() => import('./components/LessonCoursesList'));

const CoursesList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <LessonCoursesComponent />
      </Suspense>
    </div>
  );
};

export default CoursesList;
